import secureApi from '../../utils/secureApi';

export async function listAllTournaments() {
  return await secureApi.get<any>(
    '/api/v1/tournaments/website/list-all-tournaments'
  );
} 